<template>
  <div class="attachments-adder__wrapper">
    <p class="body-1 ">
      {{ $t('attachments.attach_a_file') }}
    </p>
    <p class="body-2 grey--text text--darken-2">
      {{ $t('attachments.supported_formats_are') }}
      <strong class="grey--text text--darken-2"
        >.pdf, .doc, .xls, .ppt, .csv, .jpg, .png, .gif, .zip</strong
      >
    </p>
    <p class="caption grey--text text--darken-2">
      {{
        $t('attachments.maximum_file_size', {
          maxFileSize: $constants.attachments.maxFileSizeInMB,
        })
      }}
    </p>
    <file-upload
      :multiple="true"
      :drop="true"
      :drop-directory="true"
      :accept="validFormats.join(',')"
      v-model="files"
      ref="upload"
      @input-file="inputFile"
    >
      <Button
        color="primary"
        testId="revView-button-addAttachment"
        :text="$t('attachments.choose_a_file')"
      />
    </file-upload>
  </div>
</template>

<script>
import FileUpload from 'vue-upload-component'
import Button from '@/components/UI/Button'
import _ from 'lodash'
import mime from 'mime'
import MediaSDK from '@/lib/ReverMediaSDK'

export default {
  components: {
    FileUpload,
    Button,
  },

  props: {
    validFormats: {
      type: Array,
      default() {
        return ['text/plain', 'application/pdf']
      },
      required: false,
    },
  },

  data() {
    return {
      files: [],
    }
  },

  methods: {
    async uploadFile(file) {
      try {
        const mediaObject = await MediaSDK.uploadMedia(file.file)

        this.$emit('onDoneUpload', mediaObject)
      } catch (err) {
        this.$emit('handleError', err)
      }
    },

    isValidFormat(file) {
      if (this.validFormats.includes(_.get(file, 'type'))) {
        return true
      }
      throw new Error('FORMAT_ERROR', file)
    },

    isValidSize(file) {
      if (file.size <= this.$constants.attachments.maxFileSizeInBytes) {
        return true
      }
      throw new Error('SIZE_ERROR', file)
    },

    getTypeByExtension(fileName) {
      return mime.getType(fileName)
    },

    inputFile(newFile) {
      try {
        newFile.type = newFile.type
          ? newFile.type
          : this.getTypeByExtension(newFile.name)
        this.isValidFormat(newFile)
        this.isValidSize(newFile)
        this.$emit('onFileAdded', newFile)
        this.uploadFile(newFile)
      } catch (err) {
        this.$emit('handleError', err, newFile)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.attachments-adder {
  &__title {
    color: $color-blue-grey-darken3;
    font-size: 15px;
  }
  &__subtitle {
    color: $color-blue-grey-darken1;
    font-size: 11px;
    margin: 0;
  }
  &__button {
    margin-top: 16px;
  }
}
</style>
